<script setup lang="ts">
import customerAppLogo from "@/assets/images/customer-app-logo.png";
import {useCommunicationStore} from "@/communication/stores/communication.store";

defineProps<{ content: string }>();

const {mode} = useCommunicationStore();
</script>

<template>
  <div v-if="mode==='sms'" class="flex flex-row pr-4 py-2">
    <div class="flex items-center">
      <img :src="customerAppLogo" class="w-12 h-12">
    </div>
    <div class="flex flex-1 flex-col bg-apodisPink rounded-lg p-4 ml-4">
      <span class="text-primary">{{ content }}</span>
    </div>
  </div>
</template>
